import { commonFunctions } from "../_utilities/commonFunctions";
import { configs } from "../config";
import { configes } from "../webData";

export const sellCarService = {
    sellCar
};

    function sellCar(data) {
    const requestOption = {
        method: "post",
        body: data
    };
    return fetch(
        `${configs.localApiUrl}/sellLHDCarDetail?tenantId=${configes.domainId}`,
        requestOption
    ).then((response) => response.json())
}